import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.40427 4.41112C2.40427 4.20023 2.57523 4.02927 2.78612 4.02927H21.2139C21.4248 4.02927 21.5957 4.20023 21.5957 4.41112V15.9987L13.5105 9.8159C13.2145 9.58959 12.7934 9.63383 12.5509 9.91671L9.74065 13.1953L7.56069 11.4514C7.28131 11.2279 6.87857 11.2502 6.62558 11.5031L2.40427 15.7245V4.41112ZM2.40427 17.7104V19.5869C2.40427 19.7978 2.57523 19.9688 2.78612 19.9688H21.2139C21.4248 19.9688 21.5957 19.7978 21.5957 19.5869V17.7665L13.185 11.3348L10.3651 14.6245C10.1188 14.9119 9.68898 14.9523 9.39341 14.7159L7.17418 12.9405L2.40427 17.7104ZM1 17.4196V4.41112C1 3.42467 1.79967 2.625 2.78612 2.625H21.2139C22.2003 2.625 23 3.42467 23 4.41112V17.4196V19.5869V19.5875C23 20.574 22.2003 21.3737 21.2139 21.3737H2.78612C1.79967 21.3737 1 20.574 1 19.5875V19.5869V17.4196ZM5.33589 7.93467C5.33589 7.09789 6.01424 6.41955 6.85102 6.41955C7.6878 6.41955 8.36614 7.09789 8.36614 7.93467C8.36614 8.77145 7.6878 9.4498 6.85102 9.4498C6.01424 9.4498 5.33589 8.77145 5.33589 7.93467Z"
      fill="currentColor"
    />
  </svg>
);
